export enum ButtonTitleBarView {
  Button = 'button',
  Dropdown = 'dropdown'
}
